(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/behaviors/changesubscription.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/behaviors/changesubscription.js'); "use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.tur.start_subscription.behaviors.ChangeSubscription = svs.tur.start_subscription.behaviors.Subscription.extend({
    CONSTANTS: svs.tur.start_subscription.constants,
    options() {
      return {
        entryModel: new svs.tur.start_subscription.models.ChangeEntry(),
        prefix: 'change'
      };
    },
    onChangeSubscription(_ref) {
      let {
        entry,
        options
      } = _ref;
      this.entryModel.reset();
      this.entryModel.set({
        subscriptionEntry: entry,
        subscriptionOptions: options,
        subscriptionId: entry.subscriptionIdRef
      });
      this.verifyUser();
    },
    onChangeIsVerified() {
      this.getEntryOrAnnouncement();
    },
    onChangeSubscriptionDefined() {
      this.view.triggerMethod('saveTrackingFromWager', this, () => this.triggerPrefixMethod('activationSuccess', {
        triggerView: true
      }));
    },
    onChangeActivationSuccess() {
      this.pollNewSubscription(function () {
        const flashCallback = () => window.location.href = "".concat(svs.core.urlMapping.get('myGamingsSubscriptions'), "?changeSubscription=").concat(this.entryModel.get('newSubId'));
        svs.core.flash('success', {
          title: 'Du har ändrat din prenumeration',
          message: "Det nya priset \xE4r ".concat(this.entryModel.get('subscriptionOptions').weeklyCost, " kr/vecka. Du hittar dina prenumerationsspel under Mina spel."),
          area: svs.ui.dialog.area.POPUP,
          branding: svs.ui.dialog.branding.TUR
        }, flashCallback);
      });
    },
    onChangeShowConfirmSubscription() {
      const {
        title,
        message
      } = this.getDialogChangeConfirmMessage();
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: 'subscription',
        title,
        message,
        actions: [{
          title: 'Avbryt',
          callback: () => {
            dialog.close();
          }
        }, {
          title: 'Ändra',
          callback: () => {
            dialog.close();
            this.postNewSubscription();
          }
        }]
      });
      svs.ui.dialog.api.add(dialog);
    },
    getDialogChangeConfirmMessage() {
      let {
        amount,
        payTime
      } = this.entryModel.attributes;
      const {
        paymentTypeText,
        subscriptionOptions: {
          weeklyCost,
          product
        }
      } = this.entryModel.attributes;
      amount = svs.utils.format.Currency(amount);
      payTime = svs.utils.date.FormatTime('d/M', payTime);
      return {
        title: 'Ändra din prenumeration',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: "Vill du \xE4ndra din prenumeration till ".concat(product, " f\xF6r ").concat(weeklyCost, " kr/vecka? N\xE4sta betalning p\xE5 ").concat(amount, " kr dras fr\xE5n ditt ").concat(paymentTypeText, " den ").concat(payTime),
          align: svs.ui.dialog.message.align.CENTER
        }]
      };
    }
  });
})(Backbone, _, svs);
 })(window);